import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import myLibraryActions from 'redux/actions/my_library_actions'
import { localize } from 'helpers/translator'
import PropTypes from 'prop-types'

const deleteFolderIcon = <svg height="17" width="24"> <path d="M23.36 2.5H10.13L7.54.19C7.4.07 7.21 0 7.02 0H.89C.47 0 0 .21 0 .63v15.5c0 .41.47.87.89.87h22.47c.42 0 .64-.46.64-.87v-13c0-.42-.22-.63-.64-.63zm0 0" fill="#f26c59"/> <path d="M12.5 10h8" fill="none" stroke="#fff" strokeLinecap="square" strokeWidth="2"/> </svg>

const MyLibraryRemoveFolderConfirm = props => (
	<Confirm
		btOne={localize('global_cancel')}
		btTwo={localize('global_delete')}
		alertTitle={`${localize('my_library_remove_folder_title')} ${props.folder.name}`}
		alertMessage={localize('my_library_remove_folder_message_2')}
		alertIcon={deleteFolderIcon}
		actionButtonType={1}
		actionOne={() => {
			props.actions.closeRemoveFolderConfirm()
		}}
		actionTwo={() => {
			props.actions.deleteFolderConfirmed(props.folder)
		}}
		closeAction={() => {
			props.actions.closeRemoveFolderConfirm()
		}}
	/>
)

MyLibraryRemoveFolderConfirm.propTypes = {
	actions: PropTypes.shape({
		deleteFolderConfirmed: PropTypes.func.isRequired,
		closeRemoveFolderConfirm: PropTypes.func.isRequired,
	}),
	folder: PropTypes.shape({
		name: PropTypes.string,
	}),
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeRemoveFolderConfirm: myLibraryActions.closeRemoveFolderConfirm,
		deleteFolderConfirmed: myLibraryActions.deleteFolderConfirmed,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(MyLibraryRemoveFolderConfirm)

export { MyLibraryRemoveFolderConfirm }
